import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Leaf, ArrowLeft, Mail } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import api from '../lib/api';
import { toast } from 'sonner';

export const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post('/auth/forgot-password', { email });
            setSent(true);
            toast.success('Email envoyé !');
        } catch (error) {
            toast.error('Erreur lors de l\'envoi');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-sand flex items-center justify-center p-4" data-testid="forgot-password-page">
            <Card className="w-full max-w-md border-0 shadow-xl bg-white/80 backdrop-blur-xl rounded-2xl">
                <CardHeader className="text-center pb-2">
                    <div className="w-16 h-16 mx-auto rounded-2xl bg-jungle flex items-center justify-center mb-4">
                        <Leaf className="w-9 h-9 text-sand" />
                    </div>
                    <CardTitle className="font-heading text-2xl text-jungle">Mot de passe oublié</CardTitle>
                    <CardDescription>
                        Entrez votre email pour recevoir un lien de réinitialisation
                    </CardDescription>
                </CardHeader>
                <CardContent>
                    {sent ? (
                        <div className="text-center space-y-4">
                            <div className="w-16 h-16 mx-auto bg-green-100 rounded-full flex items-center justify-center">
                                <Mail className="w-8 h-8 text-green-600" />
                            </div>
                            <p className="text-sm text-muted-foreground">
                                Si un compte existe avec l'adresse <strong>{email}</strong>, un email de réinitialisation a été envoyé. Vérifiez votre boîte de réception.
                            </p>
                            <Link to="/connexion">
                                <Button variant="outline" className="mt-4">
                                    <ArrowLeft className="h-4 w-4 mr-2" />
                                    Retour à la connexion
                                </Button>
                            </Link>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit} className="space-y-4">
                            <div className="space-y-2">
                                <Label htmlFor="email">Email</Label>
                                <Input
                                    id="email"
                                    type="email"
                                    placeholder="votre@email.fr"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    className="bg-white/80 border-jungle/20 focus:border-leaf rounded-xl"
                                    data-testid="forgot-email-input"
                                />
                            </div>
                            <Button type="submit" className="w-full bg-jungle hover:bg-jungle/90 text-sand rounded-xl h-11" disabled={loading} data-testid="forgot-submit">
                                {loading ? 'Envoi...' : 'Envoyer le lien'}
                            </Button>
                            <div className="text-center">
                                <Link to="/connexion" className="text-sm text-muted-foreground hover:text-leaf">
                                    <ArrowLeft className="h-3 w-3 inline mr-1" />
                                    Retour à la connexion
                                </Link>
                            </div>
                        </form>
                    )}
                </CardContent>
            </Card>
        </div>
    );
};
